import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import {useNavigate} from '@github-ui/use-navigate'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import {useCallback} from 'react'

import type {AppPayload} from '../types/app-payload'

type SemanticSearchFeaturePreview = {
  isAvailable: boolean
  isEnabled: boolean
  feedbackLink?: string
  toggle: () => Promise<void>
}

const useIssuesIndexSemanticSearchToggleFeaturePreview: () => SemanticSearchFeaturePreview = () => {
  const navigate = useNavigate()
  const {semantic_search_enrolled, semantic_search_feedback_url, scoped_repository} = useAppPayload<AppPayload>()
  const isAvailable = isFeatureEnabled('issues_index_semantic_search') && !!scoped_repository

  const isEnabled = semantic_search_enrolled ?? false
  const feedbackLink = semantic_search_feedback_url ?? undefined

  const toggle = useCallback(async () => {
    await verifiedFetchJSON('/feature_preview/issues_index_semantic_search/toggle', {
      method: 'POST',
    })

    // Short delay to give feature preview time to kick in
    setTimeout(() => {
      navigate('')
    }, 250)
  }, [navigate])

  return {isAvailable, isEnabled, feedbackLink, toggle}
}

export {useIssuesIndexSemanticSearchToggleFeaturePreview}
export type {SemanticSearchFeaturePreview}
